"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertString = void 0;
function assertString(input) {
    const isString = typeof input === 'string' || input instanceof String;
    if (!isString) {
        let invalidType = typeof input;
        if (input === null) {
            invalidType = 'null';
        }
        else if (typeof input === 'object' && input !== null) {
            invalidType = input.constructor.name;
        }
        throw new TypeError(`Expected a string but received a ${invalidType}`);
    }
}
exports.assertString = assertString;
